<div class="container-fluid" style="margin-top:65px;">
  <div class="row">
    <div
      class="col-xl-12 col-lg-12 col-sm-12 col-xs-12 xl-12"
      [@anim]="notifications"
    >
      <h5>{{ resp }}</h5>
      <div
        class="custom-card"
        style="margin-bottom:15px;"
        *ngFor="let n of notifications"
      >
        <div class="card-body">
          <p><mat-icon>notification_important</mat-icon>&nbsp;&nbsp; {{ n.message_title }}</p>
          <p>
            {{ n.message }}
            <span style="float:right;"
              ><small
                ><i>{{ n.date }}</i></small
              ></span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
